import { render, staticRenderFns } from "./room3.vue?vue&type=template&id=d55f200e&scoped=true&"
import script from "./room3.vue?vue&type=script&lang=js&"
export * from "./room3.vue?vue&type=script&lang=js&"
import style0 from "./room3.vue?vue&type=style&index=0&id=d55f200e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55f200e",
  null
  
)

export default component.exports